var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 477,
    height: 780,
    viewBox: "0 0 477 780",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_267_2145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.086 238.416L0.83667 393.226V670.514L226.086 515.704V238.416Z",
    stroke: "#00DFEB",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.086 274.132V238.415L199.103 256.96",
    stroke: "#00DFEB",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8197 374.681L0.83667 393.226V428.943",
    stroke: "#00DFEB",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.83667 635.232V670.513L27.8197 651.969",
    stroke: "#00DFEB",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.103 534.249L226.086 515.704V480.423",
    stroke: "#00DFEB",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.06 341.09C172.837 342.452 167.553 345.211 162.414 349.053C160.851 330.139 151.328 319.175 137.071 322.901C120.312 327.289 102.509 350.523 93.9086 377.64C78.774 380.452 61.2835 400.946 52.7746 427.07C49.923 435.815 48.4362 444.184 48.1389 451.679C30.3357 469.299 17.1225 497.083 16.9167 519.704C16.6727 546.864 35.2535 556.298 58.4243 540.775C59.202 540.252 59.9721 539.711 60.7421 539.147C60.948 539.006 61.1538 538.91 61.3597 538.769L167.355 465.92C168.24 465.312 169.101 464.628 169.955 463.892C187.354 449.856 202.794 423.458 208.115 395.989C215.199 359.468 201.741 334.883 178.06 341.078V341.09Z",
    fill: "#00DFEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.292 538.046L213.963 498.409",
    stroke: "#00DFEB",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.292 529.838L213.963 490.201",
    stroke: "#00DFEB",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.292 521.64L213.963 482.003",
    stroke: "#00DFEB",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.292 513.431L213.963 473.794",
    stroke: "#00DFEB",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.292 505.233L213.963 465.597",
    stroke: "#00DFEB",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9167 634.009L85.6361 586.779",
    stroke: "#00DFEB",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9243 635.851C17.6064 635.383 18.1594 634.17 18.1594 633.143C18.1594 632.115 17.6064 631.663 16.9243 632.132C16.2421 632.6 15.6891 633.813 15.6891 634.84C15.6891 635.868 16.2421 636.32 16.9243 635.851Z",
    fill: "#00DFEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6436 588.622C86.3258 588.153 86.8788 586.94 86.8788 585.913C86.8788 584.886 86.3258 584.433 85.6436 584.902C84.9615 585.371 84.4084 586.584 84.4084 587.611C84.4084 588.638 84.9615 589.091 85.6436 588.622Z",
    fill: "#00DFEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5078 613.665L21.0644 613.282L23.3365 621.514L22.7647 621.907L22.0403 619.11L19.509 620.85L18.7694 624.653L18.2357 625.02L20.5078 613.665ZM19.6539 620.107L21.9031 618.561L21.5066 617.066C21.2398 616.113 21.0263 615.226 20.7899 614.206L20.7518 614.232C20.5307 615.567 20.3096 616.752 20.0503 618.067L19.6462 620.112L19.6539 620.107Z",
    fill: "#00DFEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3289 611.726L23.9007 611.333L25.0672 616.156C25.3112 617.171 25.479 617.975 25.7382 618.967L25.7763 618.941C26.0432 617.575 26.2109 616.553 26.4625 615.198L27.6214 608.775L28.1628 608.403L26.0508 619.648L25.4637 620.052L23.3365 611.72L23.3289 611.726Z",
    fill: "#00DFEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1539 607.723L29.6876 607.356V617.149L29.1539 617.516V607.723Z",
    fill: "#00DFEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9076 606.517L31.4642 606.134L32.2495 611.266C32.402 612.229 32.5469 613.186 32.6841 614.159L32.7222 614.133C32.8823 612.943 33.0501 611.772 33.2254 610.595L34.2166 604.242L34.7427 603.881L35.7415 608.866C35.9092 609.818 36.0694 610.765 36.2447 611.712L36.2905 611.68C36.4201 610.512 36.5573 609.361 36.7022 608.206L37.4951 601.989L38.0136 601.633L36.5878 612.406L35.9779 612.825L34.8266 607.072C34.7198 606.365 34.6055 605.778 34.4911 605.087L34.453 605.113C34.3462 605.956 34.209 606.716 34.0946 607.575L32.9814 614.885L32.3791 615.299L30.9228 606.506L30.9076 606.517Z",
    fill: "#00DFEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7532 605.982C38.7532 602.882 39.874 600.171 41.4446 599.092C43.0153 598.012 44.1513 599.16 44.1513 602.271C44.1513 605.383 43.0381 608.146 41.4446 609.241C39.8511 610.336 38.7532 609.104 38.7532 605.982ZM43.5947 602.654C43.5947 599.99 42.7408 598.936 41.4446 599.826C40.1485 600.717 39.3174 602.942 39.3174 605.594C39.3174 608.246 40.1637 609.386 41.4446 608.506C42.7255 607.626 43.5947 605.306 43.5947 602.654Z",
    fill: "#00DFEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6457 596.387L47.5442 595.083C48.8403 594.192 49.7095 594.306 49.7095 596.212C49.7095 597.773 49.0767 599.104 48.0855 600.015L49.8391 603.299L49.2292 603.718L47.4984 600.487L46.1718 601.399V605.819L45.6381 606.186V596.393L45.6457 596.387ZM47.4222 599.874C48.543 599.103 49.1682 597.996 49.1682 596.584C49.1682 595.172 48.543 595.073 47.4222 595.844L46.1794 596.698V600.728L47.4222 599.874Z",
    fill: "#00DFEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0819 592.651L51.6156 592.285V597.6L51.6309 597.59L54.6807 590.178L55.3135 589.743L53.2473 594.803L55.6108 599.332L54.9933 599.756L52.8889 595.68L51.6156 598.771V602.078L51.0819 602.445V592.651Z",
    fill: "#00DFEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1217 597.695L56.4496 596.907C56.9223 597.386 57.5932 597.419 58.3328 596.91C59.2935 596.25 59.8958 595.067 59.8958 593.953C59.8958 592.771 59.385 592.743 58.7445 592.758L57.7762 592.781C57.1968 592.789 56.4572 592.677 56.4572 591.242C56.4572 589.807 57.273 588.224 58.3862 587.459C59.1715 586.92 59.812 586.996 60.2237 587.379L59.9187 588.117C59.5375 587.782 59.0266 587.754 58.3862 588.194C57.5551 588.765 57.0061 589.797 57.0061 590.807C57.0061 591.921 57.639 591.899 58.1117 591.884L59.08 591.862C59.8196 591.847 60.4448 592.038 60.4448 593.53C60.4448 595.023 59.6137 596.765 58.3404 597.64C57.395 598.29 56.6478 598.206 56.1293 597.701L56.1217 597.695Z",
    fill: "#00DFEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.086 590.387L0.83667 745.197V779.25L226.086 624.44V590.387Z",
    stroke: "#00DFEB",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.53 363.312L250.515 517.272V607.639L474.53 453.678V363.312Z",
    stroke: "#00DFEB",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.086 534.061L0.83667 688.871V730.96L226.086 576.151V534.061Z",
    stroke: "#00DFEB",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M25.601 679.888L8.31628 691.768V717.795L25.601 705.915V679.888Z",
    fill: "#00DFEB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M45.1044 666.484L27.8197 678.363V704.391L45.1044 692.511V666.484Z",
    fill: "#00DFEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8452 701.663L21.072 696.009",
    stroke: "#00DFEB",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9624 692.633V705.032",
    stroke: "#00DFEB",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3486 688.259L40.5754 682.605",
    stroke: "#00DFEB",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.765 344.104L250.515 498.914",
    stroke: "#00DFEB",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.515 221.626L475.765 66.8162",
    stroke: "#00DFEB",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.515 488.42V232.119",
    stroke: "#00DFEB",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.515 233.979C251.197 233.51 251.75 232.298 251.75 231.271C251.75 230.243 251.197 229.791 250.515 230.259C249.833 230.728 249.28 231.941 249.28 232.968C249.28 233.996 249.833 234.448 250.515 233.979Z",
    fill: "#00DFEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.515 490.395C251.197 489.926 251.75 488.714 251.75 487.687C251.75 486.659 251.197 486.207 250.515 486.676C249.833 487.144 249.28 488.357 249.28 489.384C249.28 490.412 249.833 490.864 250.515 490.395Z",
    fill: "#00DFEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.515 362.13C251.197 361.661 251.75 360.448 251.75 359.421C251.75 358.394 251.197 357.941 250.515 358.41C249.833 358.879 249.28 360.091 249.28 361.119C249.28 362.146 249.833 362.599 250.515 362.13Z",
    fill: "#00DFEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.515 271.637V320.752",
    stroke: "#00DFEB",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.515 399.845V448.96",
    stroke: "#00DFEB",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.765 333.61V77.3096",
    stroke: "#00DFEB",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.765 79.1698C476.447 78.7009 477 77.4881 477 76.4609C477 75.4337 476.447 74.9811 475.765 75.4499C475.083 75.9188 474.53 77.1315 474.53 78.1587C474.53 79.1859 475.083 79.6386 475.765 79.1698Z",
    fill: "#00DFEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.765 335.586C476.447 335.117 477 333.904 477 332.877C477 331.85 476.447 331.397 475.765 331.866C475.083 332.335 474.53 333.548 474.53 334.575C474.53 335.602 475.083 336.055 475.765 335.586Z",
    fill: "#00DFEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.765 207.32C476.447 206.851 477 205.639 477 204.611C477 203.584 476.447 203.131 475.765 203.6C475.083 204.069 474.53 205.282 474.53 206.309C474.53 207.336 475.083 207.789 475.765 207.32Z",
    fill: "#00DFEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.765 116.827V165.943",
    stroke: "#00DFEB",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.765 245.035V294.151",
    stroke: "#00DFEB",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.379 410.164V153.863",
    stroke: "#00DFEB",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.379 283.874C365.061 283.405 365.614 282.192 365.614 281.165C365.614 280.138 365.061 279.685 364.379 280.154C363.697 280.623 363.144 281.836 363.144 282.863C363.144 283.89 363.697 284.343 364.379 283.874Z",
    fill: "#00DFEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.379 193.381V242.496",
    stroke: "#00DFEB",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.379 321.589V370.704",
    stroke: "#00DFEB",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.115 420.655V420.081",
    stroke: "#00DFEB",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.115 418.933V165.502",
    stroke: "#00DFEB",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.115 164.927V164.354",
    stroke: "#00DFEB",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.115 294.364C349.797 293.895 350.35 292.682 350.35 291.655C350.35 290.628 349.797 290.175 349.115 290.644C348.433 291.113 347.88 292.326 347.88 293.353C347.88 294.38 348.433 294.833 349.115 294.364Z",
    fill: "#00DFEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.295 356.298L342.886 296.785",
    stroke: "#00DFEB",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.847 278.942L471.297 208.53",
    stroke: "#00DFEB",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.469 407.263L340.133 367.631",
    stroke: "#00DFEB",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.469 401.235L340.133 361.604",
    stroke: "#00DFEB",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.469 395.196L340.133 355.565",
    stroke: "#00DFEB",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.469 389.169L340.133 349.538",
    stroke: "#00DFEB",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.469 383.13L340.133 343.499",
    stroke: "#00DFEB",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.469 375.162L299.594 363.393",
    stroke: "#00DFEB",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.469 369.135L311.297 349.322",
    stroke: "#00DFEB",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.469 363.096L299.594 351.326",
    stroke: "#00DFEB",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.948 212.391L469.345 194.936",
    stroke: "#00DFEB",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.948 208.567L469.345 191.112",
    stroke: "#00DFEB",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.948 204.744L469.345 187.289",
    stroke: "#00DFEB",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.948 201.415L469.345 183.96",
    stroke: "#00DFEB",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.469 322.924L340.133 283.293",
    stroke: "#00DFEB",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.469 316.885L340.133 277.253",
    stroke: "#00DFEB",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.469 310.857L340.133 271.226",
    stroke: "#00DFEB",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.469 304.818L340.133 265.187",
    stroke: "#00DFEB",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.469 298.791L340.133 259.16",
    stroke: "#00DFEB",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.469 293.44L340.133 253.809",
    stroke: "#00DFEB",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.469 287.413L340.133 247.782",
    stroke: "#00DFEB",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.469 281.386L340.133 241.754",
    stroke: "#00DFEB",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.681 319.997L469.345 280.366",
    stroke: "#00DFEB",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M272.908 448.243L261.197 456.292V473.927L272.908 465.878V448.243Z",
    fill: "#00DFEB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M305.671 425.726L274.944 446.844V464.479L305.671 443.361V425.726Z",
    fill: "#00DFEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.497 273.549L377.081 293.766V338.381L406.497 318.164V273.549Z",
    stroke: "#00DFEB",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.494 329.85V314.351",
    stroke: "#00DFEB",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.484 332.606V303.111",
    stroke: "#00DFEB",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.481 335.357V309.57",
    stroke: "#00DFEB",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.097 321.188V283.301",
    stroke: "#00DFEB",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.087 323.944V294.449",
    stroke: "#00DFEB",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.084 326.695V305.72",
    stroke: "#00DFEB",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.681 321.856C412.363 321.387 412.916 320.175 412.916 319.147C412.916 318.12 412.363 317.668 411.681 318.136C410.999 318.605 410.446 319.818 410.446 320.845C410.446 321.872 410.999 322.325 411.681 321.856Z",
    fill: "#00DFEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.345 282.225C470.027 281.757 470.58 280.544 470.58 279.517C470.58 278.489 470.027 278.037 469.345 278.506C468.663 278.974 468.11 280.187 468.11 281.214C468.11 282.242 468.663 282.694 469.345 282.225Z",
    fill: "#00DFEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.681 209.986L469.345 170.355",
    stroke: "#00DFEB",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.681 211.847C412.363 211.378 412.916 210.165 412.916 209.138C412.916 208.11 412.363 207.658 411.681 208.127C410.999 208.596 410.446 209.808 410.446 210.835C410.446 211.863 410.999 212.315 411.681 211.847Z",
    fill: "#00DFEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.345 172.215C470.027 171.746 470.58 170.533 470.58 169.506C470.58 168.479 470.027 168.026 469.345 168.495C468.663 168.964 468.11 170.176 468.11 171.204C468.11 172.231 468.663 172.684 469.345 172.215Z",
    fill: "#00DFEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.345 293.557C470.027 293.089 470.58 291.876 470.58 290.849C470.58 289.821 470.027 289.369 469.345 289.838C468.663 290.306 468.11 291.519 468.11 292.546C468.11 293.574 468.663 294.026 469.345 293.557Z",
    fill: "#00DFEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.882 304.051L438.885 312.631L469.345 291.697",
    stroke: "#00DFEB",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.243 240.671V258.478L271.475 260.344L281.714 244.408V226.601L271.475 224.741L261.243 240.671Z",
    stroke: "#00DFEB",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.04 235.131L271.909 234.534L275.493 247.502L274.593 248.12L273.457 243.711L269.462 246.457L268.295 252.448L267.449 253.03L271.033 235.137L271.04 235.131ZM269.691 245.29L273.236 242.853L272.618 240.488C272.199 238.985 271.864 237.585 271.498 235.965L271.444 236.002C271.094 238.114 270.743 239.986 270.339 242.054L269.706 245.279L269.691 245.29Z",
    fill: "#00DFEB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M376.868 151.927V258.7L406.496 238.337V131.564L376.868 151.927Z",
    fill: "#00DFEB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M411.681 128.001V203.305L469.353 163.668V88.3646L411.681 128.001Z",
    fill: "#00DFEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.386841 326.624C0.386841 305.246 8.24767 286.64 19.5166 278.895C24.7546 275.295 28.8414 276.344 31.2126 278.928L29.1387 283.936C26.7599 281.529 23.5957 281.052 19.5166 283.855C10.1309 290.306 4.22195 305.745 4.22195 323.816C4.22195 341.887 10.0089 349.746 19.3336 343.338C23.8397 340.241 27.1945 335.088 30.3586 327.689L32.4325 329.754C29.0243 338.055 24.8766 344.488 19.1507 348.423C8.18667 355.958 0.386841 348.013 0.386841 326.647V326.624Z",
    fill: "#00DFEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0253 324.928V259.245L44.5554 256.819V323.053C44.5554 325.349 45.1654 325.94 46.0193 325.353C46.2633 325.185 46.5073 325.018 47.1782 324.373L47.7272 328.22C47.1172 328.915 46.5073 329.61 45.3483 330.406C42.4205 332.419 41.0253 330.622 41.0253 324.939V324.928Z",
    fill: "#00DFEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6121 298.437C54.6121 282.111 61.436 267.972 69.2968 262.57C77.1576 257.167 83.9815 261.926 83.9815 278.252C83.9815 294.578 77.1576 308.533 69.2968 313.935C61.436 319.338 54.6121 314.671 54.6121 298.437ZM80.3218 280.767C80.3218 268.287 75.6327 262.888 69.2968 267.242C62.9608 271.597 58.3328 283.4 58.3328 295.88C58.3328 308.359 62.9608 313.709 69.2968 309.354C75.6327 305 80.3218 293.247 80.3218 280.767Z",
    fill: "#00DFEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.986 278.849V247.563L96.5238 245.132V275.774C96.5238 285.774 98.5976 289.033 103.592 285.601C107.366 283.007 110.05 278.223 113.702 269.112V233.326L117.232 230.899V279.797L114.243 281.851L113.938 273.989L113.755 274.115C110.591 281.789 107.297 287.819 102.791 290.916C96.0282 295.564 92.9784 291.426 92.9784 278.854L92.986 278.849Z",
    fill: "#00DFEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.74 248.865C126.74 233.09 133.441 218.484 141.119 213.207C145.015 210.53 147.638 210.931 150.81 212.506L150.566 203.867V183.959L154.096 181.533V254.472L151.168 256.484L150.802 250.593L150.619 250.719C147.997 256.471 144.405 262.326 140.204 265.213C132.039 270.826 126.74 265.294 126.74 248.876V248.865ZM150.558 245.709V217.455C147.326 215.268 144.527 215.549 141.478 217.645C135.264 221.916 130.514 234.262 130.514 246.283C130.514 258.946 134.227 264.649 140.807 260.127C144.276 257.742 147.326 252.983 150.558 245.721V245.709Z",
    fill: "#00DFEB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_267_2145"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 578.325,
    height: 492.659,
    fill: "white",
    transform: "matrix(0.824126 -0.566406 0 1 0.386841 287.175)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudService);
export default __webpack_public_path__ + "static/media/cloud_service.8cfcdea6d2973fed866f60f000bda067.svg";
export { ForwardRef as ReactComponent };